import { disablePageScroll, enablePageScroll } from '@fluejs/noscroll'

export const isIOS =
  /iPad|iPhone|iPod/.test(window.navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

export function debounce(func, wait = 50, immediate = false) {
  let timeout

  return function (...args) {
    const context = self
    const later = () => {
      timeout = null
      if (!immediate) {
        func.apply(context, args)
      }
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) {
      func.apply(context, args)
    }
  }
}

export function throttle(func, wait = 100) {
  let timeout = null
  let previous = 0

  return function (...args) {
    const now = Date.now()
    const remaining = wait - (now - previous)

    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout)
        timeout = null
      }
      previous = now
      // eslint-disable-next-line no-invalid-this -- preserve throttled caller context
      func.apply(this, args)
    } else if (!timeout) {
      timeout = setTimeout(() => {
        previous = Date.now()
        timeout = null
        // eslint-disable-next-line no-invalid-this -- preserve throttled caller context
        func.apply(this, args)
      }, remaining)
    }
  }
}

export function isEqual(a, b) {
  return JSON.stringify(a) === JSON.stringify(b)
}

export function kebabCase(str) {
  const result = str.replace(
    /[A-Z\u00C0-\u00D6\u00D8-\u00DE]/g,
    (match) => '-' + match.toLowerCase()
  )
  return str[0] === str[0].toUpperCase() ? result.substring(1) : result
}

export function getRootFontSize() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize)
}

export function pxToRem(px) {
  return px / getRootFontSize()
}

let savedScrollY = 0
let scrollDisabledByUs = false

export function disableScroll() {
  disablePageScroll()
  scrollDisabledByUs = true

  if (isIOS) {
    savedScrollY = window.scrollY
    document.body.style.position = 'fixed'
    document.body.style.top = `-${savedScrollY}px`
    document.body.style.width = '100%'
  }
}

export function enableScroll() {
  enablePageScroll()

  if (isIOS) {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    window.scrollTo({ top: savedScrollY, behavior: 'auto' })
  }

  setTimeout(() => {
    scrollDisabledByUs = false
  }, 300)
}

export function isScrollDisabled() {
  return scrollDisabledByUs
}

window.disableScroll = disableScroll
window.enableScroll = enableScroll
